import { APIGET, APIPOST } from '@/util/http'

export function getCompanyList(query) {
  return APIGET('company/list', query)
}

export function postAddCompanyInfo(data) {
  return APIPOST('company/edit', data)
}

// export function getMenusList() {
//   return APIGET('company/menusList')
// }

export function getMenusList() {
  return APIGET('sys/menusList')
}

export function getStaffList() {
  return APIGET('company/staffList')
}
